import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-handheld-home",
  templateUrl: "./handheld-home.component.html",
  standalone: false,
})
export class HandheldHomeComponent {
  constructor(private router: Router) {}

  goToProcessFlow() {
    this.router.navigate(["/handheld/process-bins"]);
  }
}
